<template>
    <div class="content">
        <sub-title title="联系我们"></sub-title>

        <div class="contact-info">
            <div>
                <img :src="require('@/static/images/about/phone.png')" />
                <label>{{myData.mobile}}</label>
            </div>
            <div>
                <img :src="require('@/static/images/about/pos.png')" />
                <label>{{myData.address}}</label>
            </div>
        </div>
        <client-only>
            <img :src="require('@/static/images/map.png')" style="height:500px;width:100%;margin-top:30px;"/>
            <!-- <baidu-map
                class="bdwindow"
                :dragging="dragging"
                :center="myData.mapPosition"
                :zoom="zoom"
            > -->
                <!-- :scroll-wheel-zoom='scroll' -->
                <!-- <bm-marker
                    :position="myData.mapPosition"
                    :dragging="true"
                > -->
                    <!-- animation="BMAP_ANIMATION_BOUNCE" -->
                <!-- </bm-marker>
            </baidu-map> -->
        </client-only>
    </div>
</template>

<script>
import SubTitle from './sub-title.vue';
export default {
    components: { SubTitle },
    computed:{
        myData(){
            return this.webInfo.about.lxwm
        },
    },
    data() {
        return {
            zoom: 20, //缩放级别
            scroll: true, //地图缩放
            dragging: true, //地图拖拽
        };
    },
    mounted() {},
    methods: {},
};
</script>
<style lang='scss' scoped>
.content {
    padding-top: 72px;
    padding-bottom: 141px;

    .contact-info {
        display: flex;
        justify-content: space-between;
        font-size: 18px;
        color: #333333;
        padding: 0px 96px;
        margin-top: 62px;

        img {
            width: 18px;
            height: 18px;
            vertical-align: middle;
        }
    }
}
.bdwindow {
    height: 442px;
    width: 1118px;
    margin: 0 auto;
    margin-top: 44px;
}
</style>
